module.exports = {
      id: "ic-fibonacci-fan-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite-ad374a.smartcharts.svg#ic-fibonacci-fan-usage",
      toString: function () {
        return this.url;
      }
    }